<template>
    <gatewayDetailWin :detailObj="detailObj" :deviceType="deviceType" :deviceProperty="deviceProperty" :netObj="netObj"
        v-bind="$attrs" ref="detailDialog"></gatewayDetailWin>
</template>

<script>
import gatewayDetailWin from './component/gatewayDetailWin.vue'
import { getGatewayDetailInfo } from '@/api/modules/gateway'
export default {
    data() {
        return {
            detailObj: {},
            deviceType: {},
            deviceProperty: {},
            netObj: {},
        }
    },
    components: {
        gatewayDetailWin
    },
    methods: {
        detailFn(id) {
            getGatewayDetailInfo(id).then(({ result }) => {
                result.gateway.pictureBase64 = result.gateway.pictureBase64 || result.deviceType.pictureBase64;
                // let url = `${sensor.fullPath}/${sensor.carrierName}`;
                result.gateway.url = `${result.gateway.fullPath}/${result.gateway.carrierName}`
                // 基础信息
                this.detailObj = Object.assign(result.gateway, result.deviceProperty || {}, result.deviceType || {});
                // 属性信息
                this.deviceType = result.deviceType;
                this.deviceProperty = result.deviceProperty || {};
                // 网关参数
                this.netObj = result.netConfig || {}
            })
        },
    },
    mounted() {
        if (this.$route.query && this.$route.query.id) {
            const { id } = this.$route.query
            this.detailFn(id);
        }
    },

}
</script>

<style>
</style>